import { render } from "./UserManagementModal.vue?vue&type=template&id=3e52d05c&scoped=true"
import script from "./UserManagementModal.vue?vue&type=script&lang=js"
export * from "./UserManagementModal.vue?vue&type=script&lang=js"

import "./UserManagementModal.vue?vue&type=style&index=0&id=3e52d05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e52d05c"]])

export default __exports__